import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { SplashScreenService } from '../services/splash-screen.service';

@Component({
    selector: 'app-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss'],
    standalone: false
})
export class SplashScreenComponent {
  imageSrc: string = '';
  isLoaded = false;
  imagesLoadedCount = 0;
  isMenuClosed = false;
  isConnectionError = false;
  languages: string[] = ['en', 'ar', 'ru'];

  menuClosedMessage: { [key: string]: string } = {
    en: 'Our menu is currently closed for ordering. We apologize for the inconvenience.',
    ar: 'قائمة الطعام مغلقة حالياً للطلب. نعتذر عن الازعاج',
    ru: 'Наше меню в настоящее время закрыто для заказов. Приносим извинения за неудобства'
  }

  constructor(
    private splashScreenService: SplashScreenService,
  ) {
    effect(() => {
      const state = this.splashScreenService.splashState();

      switch (state.status) {
        case 'splash':
          this.isLoaded = false;
          this.isMenuClosed = false;
          this.isConnectionError = false;
          this.imageSrc = state.imageUrl || '';
          this.scheduleAutoHide();
          break;
        case 'menuClosed':
          this.isLoaded = false;
          this.isMenuClosed = true;
          this.isConnectionError = false;
          this.imageSrc = state.imageUrl || '';
          this.languages = state.languages || ['en', 'ar', 'ru'];
          break;
        case 'connectionError':
          this.isLoaded = false;
          this.isMenuClosed = false;
          this.isConnectionError = true;
          break;
        case 'idle':
          this.isLoaded = true;
          break;
      }
    });
  }

  hideSplash(): void {
    if (!this.imageSrc || this.isMenuClosed || this.isConnectionError) return;
    this.splashScreenService.updateSplashStatus('idle');
  }

  retry(): void {
    window.location.reload();
  }

  /* This method is to keep track of the images loaded and increment the counter on each image lazy load.
     First image loaded is the bouncing 'powered by opaala' and the second is the splash screen.
     So when the splash screen is lazy loaded, the counter would be 2.
  */
  markLoaded(): void {
    if (this.imageSrc) {
      this.imagesLoadedCount++; // first image loaded is bouncing 'powered by opaala' and the second is the splash screen.
    }
  }

  private scheduleAutoHide(): void {
    setTimeout(() => {
      this.splashScreenService.updateSplashStatus('idle');
    }, 10000);
  }
}